import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UILink from 'UIComponents/link/UILink';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { FEATURED_CALLOUT_LAYOUT_TYPES } from 'marketplace-ui-common/callouts/constants/FeaturedCallouts';
import { useIsMaxScreenSize } from 'marketplace-ui-common/hooks/useScreenSize';
import { useFeaturedCallouts } from 'marketplace-ui-common/callouts/hooks/useFeaturedCallouts';
import CoreFeaturedCallout from 'marketplace-ui-common/callouts/components/FeaturedCallout';
import ValidI18nMessage from 'marketplace-ui-common/i18n/components/ValidI18nMessage';
import SanitizedText from 'sanitize-text/components/SanitizedText'; //@ts-expect-error untyped dependency

import { getIsPublic } from '../../selectors/auth';
import { useCollections } from 'marketplace-ui-common/collections/hooks/useCollections';
import { useAppContext } from '../../context/AppContext.tsx';
import { useContext } from 'react';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext'; // @ts-expect-error untyped import

import { getIsUngatedForLinguine } from '../../selectors/auth';

function FeaturedCallout({
  callout,
  layout
}) {
  const {
    id,
    publishedListing
  } = callout;
  const {
    collectionId,
    externalUrl
  } = publishedListing;
  const appContext = useAppContext();
  const {
    trackInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const isLinguineUngated = useSelector(getIsUngatedForLinguine);
  const {
    data: collections
  } = useCollections({
    appContext,
    offeringType: 'APP'
  });
  const collection = collections.find(c => c.id === collectionId);
  const LinkComponent = collection ? UIRouterLink : UILink;
  const link = collection && collection.publishedListing ? `/${collection.publishedListing.slug}` : externalUrl;
  const i18nKey = typeof id === 'string' ? id : `featuredCallout_${id}`;
  if (!link) return null;
  return /*#__PURE__*/_jsx(CoreFeaturedCallout, {
    buttonText: isLinguineUngated ? /*#__PURE__*/_jsx(SanitizedText, {
      body: publishedListing.buttonText,
      WrapperComponent: "span"
    }) : /*#__PURE__*/_jsx(ValidI18nMessage, {
      defaultValue: publishedListing.buttonText,
      message: `appMarketplace.featuredCallouts.${i18nKey}.buttonText`
    }),
    external: !!externalUrl,
    description: isLinguineUngated ? /*#__PURE__*/_jsx(SanitizedText, {
      body: publishedListing.description,
      WrapperComponent: "span"
    }) : /*#__PURE__*/_jsx(ValidI18nMessage, {
      defaultValue: publishedListing.description,
      message: `appMarketplace.featuredCallouts.${i18nKey}.description`
    }),
    gradientColor: publishedListing.gradientColor,
    headline: isLinguineUngated ? /*#__PURE__*/_jsx(SanitizedText, {
      body: publishedListing.headline,
      WrapperComponent: "span"
    }) : /*#__PURE__*/_jsx(ValidI18nMessage, {
      defaultValue: publishedListing.headline,
      message: `appMarketplace.featuredCallouts.${i18nKey}.headline`
    }),
    illustrationName: publishedListing.illustration,
    layout: layout,
    Link: LinkComponent,
    linkProps: collection ? {
      to: link
    } : {
      href: link
    },
    onClick: () => {
      trackInteraction('click featured callout', {
        section: `featured-callout::${i18nKey}::static`
      });
    },
    responsive: true
  });
}

export default function FeaturedCalloutsSection() {
  const isPublicApp = useSelector(getIsPublic);
  const isMobile = useIsMaxScreenSize('sm');
  const {
    data: callouts
  } = useFeaturedCallouts({
    appContext: isPublicApp ? 'public' : 'app',
    offeringType: 'APP'
  });
  if (callouts.length === 0) return null;
  const isSingleColumn = isMobile || callouts.length === 1;
  const columns = isSingleColumn ? 1 : 2;
  const layout = isSingleColumn ? FEATURED_CALLOUT_LAYOUT_TYPES.FULL_WIDTH : FEATURED_CALLOUT_LAYOUT_TYPES.MULTI;
  return /*#__PURE__*/_jsx(UICardGrid, {
    columns: columns,
    className: "p-bottom-10",
    children: callouts.map(callout => /*#__PURE__*/_jsx(FeaturedCallout, {
      callout: callout,
      layout: layout
    }, callout.id))
  });
}